import { render, staticRenderFns } from "./appointmentsListPanel.vue?vue&type=template&id=6db0e1d0&"
import script from "./appointmentsListPanel.vue?vue&type=script&lang=js&"
export * from "./appointmentsListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports